var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlusMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "12pt",
    height: "12pt",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 0.5 L 11.5 0.5 L 11.5 11.5 L 0.5 11.5 Z M 0.5 0.5 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.431373%,63.529412%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 6.582031 9.082031 C 6.269531 9.082031 6.011719 9.335938 6.011719 9.652344 C 6.011719 9.964844 6.269531 10.222656 6.582031 10.222656 L 10.953125 10.222656 C 11.269531 10.222656 11.523438 9.964844 11.523438 9.652344 C 11.523438 9.335938 11.269531 9.082031 10.953125 9.082031 Z M 0.5 3.949219 C 0.5 4.261719 0.757812 4.519531 1.070312 4.519531 L 2.59375 4.519531 L 2.59375 6.039062 C 2.59375 6.355469 2.847656 6.609375 3.164062 6.609375 C 3.476562 6.609375 3.730469 6.355469 3.730469 6.039062 L 3.730469 4.519531 L 5.441406 4.519531 C 5.757812 4.519531 6.011719 4.261719 6.011719 3.949219 C 6.011719 3.636719 5.757812 3.378906 5.441406 3.378906 L 3.730469 3.378906 L 3.730469 1.476562 C 3.730469 1.164062 3.476562 0.910156 3.164062 0.910156 C 2.847656 0.910156 2.59375 1.164062 2.59375 1.476562 L 2.59375 3.378906 L 1.070312 3.378906 C 0.757812 3.378906 0.5 3.636719 0.5 3.949219 Z M 10.753906 1.847656 C 10.53125 1.625 10.171875 1.625 9.945312 1.847656 L 1.652344 10.144531 C 1.429688 10.363281 1.429688 10.726562 1.652344 10.949219 C 1.765625 11.0625 1.910156 11.117188 2.054688 11.117188 C 2.199219 11.117188 2.347656 11.0625 2.457031 10.949219 L 10.753906 2.652344 C 10.976562 2.433594 10.976562 2.070312 10.753906 1.847656 Z M 10.753906 1.847656 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusMinus);
export default __webpack_public_path__ + "static/media/icon-plus-minus.0a6365e2223342259002344aba8b0044.svg";
export { ForwardRef as ReactComponent };